import {
    Backend,
    isMobile,
    get_csrf_jwt_token,
    isVkPlay,
    isDevGem,
    setScriptTag,
    getGemHost,
    copyTextToClipboard,
} from '@vkplay/shared';

function onHeaderLoad() {
    const header = document.getElementById("js-b-header");
    const browserWarning = document.querySelector(".js-browser-warning");
    const reviewsWidget = document.querySelector(".js-reviews-widget");
    const flashWarning = document.querySelector(".js-flash-warning");
    const browserWarningHeight = browserWarning ? browserWarning.offsetHeight : 0;
    const flashWarningHeight = flashWarning ? flashWarning.offsetHeight : 0;
    const reviewsWidgetHeight = (!window.matchMedia('(orientation: landscape)').matches && reviewsWidget) ? reviewsWidget.offsetHeight : 0;
    const $mainBlock = document.getElementById("promo");
    const $subscriptionBLock = document.getElementById("root-subscription");
    const height = window.innerHeight - header.offsetHeight - browserWarningHeight - flashWarningHeight - reviewsWidgetHeight + "px";

    if ($mainBlock) {
        $mainBlock.style.height = height;
    }

    if ($subscriptionBLock) {
        let needToLoad;

        Backend.api_get('/play/games/get/', {
            id: window.appid
        }).then((resp) => {
            const feature_flags = resp.feature_flags || [];
            needToLoad = !feature_flags.includes('azerion') && isVkPlay; // грузим везде кроме азерион

            needToLoad && Backend.api_get('/social/online/get_extended', {id: window.appid }).then(resp => {
                if (resp.status === 'ok') {
                    const data = resp.data || {};
                    const login = Object.keys(data)[0];
                    const project = login && data[login].filter(game => window.appid === game.project.id)[0];
                    const timeSpend = project && project.time >= 7200; // наиграл больше 2 часов
                    if (timeSpend) {
                        const rnd = Math.random();
                        const url = `https://${isDevGem ? "store.dev-" : ""}vkplay.ru/hotbox/showcase/frontend/release/subscription.js`
                        setScriptTag({
                            src: url,
                            onload: () => {
                                window.partner_resize && window.partner_resize()
                            }
                        })
                    }
                }
            }).catch(e => {
                console.warn(e)
            })

        }).catch((error) => {
            console.warn(error);
        })
    }
}

(function handshake(iframeApi) {
    window.iFrameApiParent = true;

    function gtmPushEvent(config) {
        var isGTMDataLayerExists = window.dataLayer && window.dataLayer.push;

        if (isGTMDataLayerExists) {
            window.dataLayer.push(config);
        }
    }

    function getUrlParam(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
            return null;
        }
        else {
            return results[1] || 0;
        }
    }

    function exitFullScreen() {
        if (document.fullscreenElement) {
            document.exitFullscreen()
                .catch((err) => console.error(err));
        }
    }

    var registerParams = {};
    var paramNames = ["_1ld", "_1lp", "mr1lext", "_fbc", "_fbp", "_ga"];
    for (var i = 0; i < paramNames.length; i++) {
        var paramValue = getUrlParam(paramNames[i]);
        if (paramValue) {
            registerParams[paramNames[i]] = paramValue;
        }
    }

    var appid = window.parent
        && window.parent.partner_settings
        && window.parent.partner_settings.appid
        || 1;

    var isBattleArena = appid === '3800';
    var isGlobalCity = appid === '5728' || appid === '19663';
    var appEventName = isBattleArena ? 'BattleArena' : isGlobalCity ? 'GlobalCity' : '';
    var isMiniHost = window.location.hostname === getGemHost("mini");

    var platform_domain = window.partner_settings
            && window.partner_settings.platform_domain
            || 'games.mail.ru',
        register_mode = window.partner_settings
            && window.partner_settings.register_mode
            || false;

    window.__GEMS = {
        ...window.__GEMS || {},
        enable_tmr: 0,
        onProjectRegister: (resp) => {
            return get_csrf_jwt_token().then(token => {
            if (resp.status === 200 || resp.status === 446) {
                $.ajax({
                    url: `/app/${appid}/user/register`,
                    data: {...registerParams, ...{csrfmiddlewaretoken_jwt: token}},
                    xhrFields: {
                        withCredentials: true
                    },
                    method: 'POST',
                    success: function (data){
                        if (data && data.status === "ok") {
                            window.location.reload();
                        }
                        else {
                            console.warn('Project register error', resp);
                        }
                    }
                });
            } else {
                console.warn('Project register error', resp);
            }
            })
        },
        onUserTermsAccept: () => {
            window.location.reload();
        },
        whenLoaded: () => {
            onHeaderLoad();
        },
        onGetProfile: (profile) => {
            window.__gem_profile = profile;
        },
        onFormClose: (type) => {
            if (type === "login" || type === "signup") {
                mailru?.external?.closeAuthFormCallback && mailru.external.closeAuthFormCallback();
            }
        },
    };

    if (window.is_gem && !isMiniHost) {
        const hasFooter = document.getElementById('shell-footer');

        if (window.EVA) {
            window.EVA.init('js-b-header', {
                simplified: true,
                enableWSD: true,
                ...(hasFooter ? {
                    footerSelector: '#shell-footer',
                } : {
                    hideFooter: true,
                }),
                onReady: () => {
                    onHeaderLoad();
                },
                onGetUser: (user) => {
                    window.current_user = user.session;
                    window.dispatchEvent(new CustomEvent('gem_login', { detail: user.session }));
                },
                onInitWSD: (wsd) => {
                    window.__gem_wsd = wsd;
                    window.dispatchEvent(new CustomEvent('init_wsd', { detail: wsd }));
                }
            });
        }
    }

    const insertAdsFrame = (useStage = false) => (config = {}) => {
        const getRelevantAdsOrigin = () => {
            const isVkplayHost = window.location.hostname.endsWith('vkplay.ru');
            const isMiniVkplayHost = window.location.hostname.endsWith('mini.vkplay.ru');

            switch (true) {
                case isMiniVkplayHost:
                    return 'https://mini.vkplay.ru';
                case isVkplayHost:
                    return 'https://vkplay.ru';
                default:
                    return 'https://store.my.games';
            }
        };
        const getProdAdsUrl = () => `${getRelevantAdsOrigin()}/vendos/vendo.html`;
        const getAdsUrl = () => {
            const ADS_STAGE_URL = 'https://store.dev-vkplay.ru/vendos/vendo.html';

            return useStage
                ? ADS_STAGE_URL
                : getProdAdsUrl();
        };
        const buildIframeSrc = (baseUrl) => {
            const url = new URL(baseUrl);
            const searchParams = {
                ...config,
                interstitial: config.interstitial ? "true" : "false",
                gcid: config.gcid || window.__GEMS.gc_id || window.gc_id,
                game_platform: 'WEB',
            };

            if(isMiniHost) {
                const myTargetIdParamName = 'mtl_id';
                const myTargetId = localStorage.getItem(myTargetIdParamName);

                if(myTargetId) {
                    searchParams[myTargetIdParamName] = myTargetId
                }
            }

            for (let param in searchParams) {
                if (searchParams[param] !== undefined) {
                    url.searchParams.append(param, searchParams[param]);
                }
            }

            return url.href;
        };
        const insertIframe = (src) => {
            const iframeStyle = `
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
                z-index: 999999999;
            `;
            const iframeHtml = `
                <iframe
                    id="ads_frame"
                    style="${iframeStyle}"
                    src="${src}"
                    width="100%"
                    height="100%"
                >
                </iframe>
            `;

            $('body').prepend(iframeHtml);
        };

        insertIframe(buildIframeSrc(getAdsUrl()));

        if (isMiniHost) {
            window.dispatchEvent(new CustomEvent("toggle_ads_from_game_api", { detail: "show" }));
        }
    };

    var mailru = {
        platformUrl: 'https://' + platform_domain + '/app/',
        external: null,
        paymentWaitMutex: false,
        paymentParams: {},
        getLoginStatus: function () {
            console.log('mailru.getLoginStatus called');
            var that = this;
            $.ajax({
                url: this.platformUrl+this.external.appid+'/user/status',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    console.log('mailru.getLoginStatusCallback called');
                    that.external.getLoginStatusCallback(data);
                }
            });
        },
        authUser: function () {
            console.log('mailru.authUser called');
            exitFullScreen();

            if (window.EVA) {
                window.EVA.showLogin();
            }
        },
        userInfo: function(){
            console.log('mailru.userInfo called');
            var that = this;
            $.ajax({
                url: this.platformUrl+this.external.appid+'/user/info',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data){
                    that.external.userInfoCallback(data);
                }
            });
        },
        userProfile: function(){
            console.log('mailru.userProfile called');
            var that = this;
            $.ajax({
                url: this.platformUrl+this.external.appid+'/user/profile',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data){
                    if (that.external.userProfileCallback) {
                        that.external.userProfileCallback(data);
                    }
                }
            });
        },
        userFriends: function(){
            console.log('mailru.userFriends called');
            var that = this;
            $.ajax({
                url: this.platformUrl+this.external.appid+'/user/friends',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data){
                    if (that.external.userFriendsCallback) {
                        that.external.userFriendsCallback(data);
                    }
                }
            });
        },
        userSocialFriends: function(){
            console.log('mailru.userSocialFriends called');
            var that = this;
            $.ajax({
                url: this.platformUrl+'user/socialfriends',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data){
                    if (that.external.userSocialFriendsCallback) {
                        that.external.userSocialFriendsCallback(data);
                    }
                }
            });
        },
        registerUser: function (args) {
            console.log('mailru.registerUser called');
            return get_csrf_jwt_token().then(token => {
            var that = this;
            if (register_mode) {
                $.ajax({
                    url: that.platformUrl+that.external.appid+'/user/register?confirm=0',
                    data: {...registerParams, ...{csrfmiddlewaretoken_jwt: token}},
                    xhrFields: {
                        withCredentials: true
                    },
                    method: 'POST',
                    success: function (data){
                        if (isBattleArena || isGlobalCity) {
                            gtmPushEvent({ event: `${appEventName}_Registration` });
                        }

                        if (isMiniHost) {
                            window.dispatchEvent(new CustomEvent("register_user_from_game_api", { detail: data }));
                            if (window.location.search.includes("debug_register=1")) {
                                that.external.registerUserCallback && that.external.registerUserCallback(data);
                            }
                        }

                        if (!isMiniHost && that.external.registerUserCallback) {
                            that.external.registerUserCallback(data);
                        }
                    }
                });
            }
            else {
                ovl_open('/user/confirm', {}, 350, 'js-register');
            }
            })
        },
        registerUserNoConfirm: function (args) {
            console.log('mailru.registerUserNoConfirm called');
            return get_csrf_jwt_token().then(token => {
            var that = this;
            $.ajax({
                url: that.platformUrl+that.external.appid+'/user/register?confirm=0',
                data: {...registerParams, ...{csrfmiddlewaretoken_jwt: token}},
                xhrFields: {
                    withCredentials: true
                },
                method: 'POST',
                success: function (data){
                    if (isBattleArena || isGlobalCity) {
                        gtmPushEvent({ event: `${appEventName}_Registration` });
                    }

                    if (that.external.registerUserCallback) {
                        that.external.registerUserCallback(data);
                    }
                }
            });
            })
        },
        userConfirmCheck: function (args) {
            console.log('mailru.userConfirmCheck called');
            var that = this;
            $.ajax({
                url: that.platformUrl+that.external.appid+'/user/confirm_check',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data){
                    that.external
                    && that.external.userConfirmCheckCallback
                    && that.external.userConfirmCheckCallback(data);
                }
            });
        },
        userConfirm: function (args) {
            console.log('mailru.userConfirm called');
            var that = this;
            ovl_open('/user/confirm?continue=1', {}, 350, 'js-confirm');
        },
        openSteamPaymentFrame: function (args) {
            const that = this;
            const url = this.platformUrl+this.external.appid+'/billing?url=1';

            $.ajax({
                type: 'POST',
                url: url,
                data: args,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data){
                    window.gc_steam_open_overlay_url && window.gc_steam_open_overlay_url(data, () => {
                        that.paymentWindowClosed();
                    });
                }
            });
        },
        paymentFrame: function (args) {
            console.log('mailru.paymentFrame called with args: ', args);

            if (window.gc_is_steam_mode && window.gc_is_steam_mode()) {
                console.log('Open steam payment overlay');
                this.openSteamPaymentFrame(args);
            } else {
                ovl_open('/billing/frame', args, window.screen.width >= 781 ? 781 : window.screen.width, 'ovl-billing js-billing');
            }

            if (isBattleArena || isGlobalCity) {
                var params = args.merchant_param || {};

                this.paymentParams = params;

                gtmPushEvent({
                    event: `${appEventName}_InitialCheckout`,
                    amount: params.amount || 0,
                    currency: params.currency || 'RUB'
                });
            }

            gtmPushEvent({
                event: `payment_frame_open`,
                displayMode: window.getDisplayMode ? window.getDisplayMode() : 'browser',
                PWAppID: window.appid,
            });
        },
        paymentFrameItem: function (args) {
            console.log('mailru.paymentFrameItem called with args: ', args);
            ovl_open('/billing/item/frame', args, window.screen.width >= 700 ? 700 : window.screen.width, 'ovl-billing js-billing');
        },
        paymentFrameUrl: function (args) {
            console.log('mailru.paymentFrameUrl called with args: ', args);
            var that = this;
            $.ajax({
                type: 'POST',
                url: this.platformUrl+this.external.appid+'/billing/frame?url=1',
                data: args,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data){
                    that.external.paymentFrameUrlCallback(data);
                }
            });
        },
        getAuthToken: function(){
            var that = this;
            $.ajax({
                type: 'POST',
                url: this.platformUrl+this.external.appid+'/gas/token',
                headers: {'X-Requested-With': 'XMLHttpRequest'},
                xhrFields: {
                    withCredentials: true
                },
                success: function (data){
                    that.external.getAuthTokenCallback(data);
                }
            });
        },
        getGameInventoryItems: function(){
            var that = this;
            $.ajax({
                type: 'GET',
                url: this.platformUrl+this.external.appid+'/billing/item/list',
                xhrFields: {
                    withCredentials: true
                },
                success: function (data){
                    that.external.getGameInventoryItemsCallback(data);
                }
            });
        },
        paymentReceived: function(data){
            console.log('mailru.paymentReceived called');
            var that = this;
            that.paymentWaitMutex = false;

            if (isBattleArena || isGlobalCity) {
                var params = that.paymentParams;

                gtmPushEvent({
                    event: `${appEventName}_Purchase`,
                    amount: params.amount || 0,
                    currency: params.currency || 'RUB'
                });
            }

            if (that.external.paymentReceivedCallback) {
                that.external.paymentReceivedCallback(data);
            }
        },
        paymentWait: function(){
            console.log('mailru.paymentWaitCallback called');
            var that = this;
            that.paymentWaitMutex = true;
            if (that.external.paymentWaitCallback) {
                that.external.paymentWaitCallback();
            }
        },
        paymentInvoice: function(){
            console.log('mailru.paymentInvoiceCallback called');
            var that = this;
            that.paymentWaitMutex = false;
            if (that.external.paymentInvoiceCallback) {
                that.external.paymentInvoiceCallback();
            }
        },
        paymentWindowClosed: function(){
            console.log('mailru.paymentWindowClosed called');
            var that = this;
            that.paymentWaitMutex = false;
            if (that.external.paymentCanceledCallback) {
                that.external.paymentCanceledCallback();
            }
            if (that.external.paymentWindowClosedCallback) {
                that.external.paymentWindowClosedCallback();
            }
        },
        paymentCanceled: function(){
            console.log('mailru.paymentCanceledCallback called');
            var that = this;
            that.paymentWaitMutex = false;
            if (that.external.paymentCanceledCallback) {
                that.external.paymentCanceledCallback();
            }
        },
        confirmWindowClosed: function(){
            console.log('mailru.confirmWindowClosed called');
            var that = this;
            if (that.external.confirmWindowClosedCallback) {
                that.external.confirmWindowClosedCallback();
            }
        },
        reloadWindow: function(){
            console.log('mailru.reloadWindow called');
            window.location.reload();
        },
        _showAdsDebug: insertAdsFrame(true),
        showAds: insertAdsFrame(false),
        //TODO удалить после выкатки новой версии postMessage с games-frontend
        transmitAdsCallback: function (type) {
            this.external.adsCallback({type})
            if (type !== "adReady") {
                setTimeout(function () {
                    $("#ads_frame").remove();
                    if (isMiniHost) {
                        window.dispatchEvent(new CustomEvent("toggle_ads_from_game_api", { detail: "hide" }));
                    }
                }, 1000);
            }
        },
        transmitAdsObjectCallback: function (event) {
            this.external.adsCallback(event);
            if (event.type !== "adReady") {
                setTimeout(function () {
                    $("#ads_frame").remove();
                }, 1000);
            }
        },
        isMobile: function() {
            return isMobile;
        },
        copyTextToClipboard: function (str) {
            console.log('mailru.copyTextToClipboard called:', str);
            var that = this;
            copyTextToClipboard(str, function () {
                if (that.external.copyTextSuccessCallback) {
                    that.external.copyTextSuccessCallback();
                }
            });
        },
        version: '0.1.0' // primitive values are also allowed
    };


    $(document).ready(function() {
        onWSDInit();
    });

    $(window).on('WSDInit', function() {
        onWSDInit();
    });

    function onWSDInit() {
        if (window.WSD) {
            WSD.on('message', function(msg) {
                if (msg && msg['type'] == 'partner_payment') {
                    delete msg['type'];
                    mailru.paymentReceived(msg)
                }
            });
        }
    }

    function processDmrCallback(e) {
        if ((e.origin != 'https://pw.money.mail.ru') && (e.origin != 'https://co.vkpay.io')) {
            console.log('processDmrCallback: ignored origin' + e.origin);
            return;
        }

        var data = e.data.payload ? e.data.payload : e.data;
        if (!e.data.payload && typeof data === 'string') {
            try {
                var data = JSON.parse(data);
            } catch (err) {
                console.log("Invalid JSON: " + data);
                return;
            }
            if (data.action) {
                console.log('action: ' + data.action);
                if (data.action == 'closeWindow') {
                    $('.js-ovl-close').trigger('click');
                }
                else if (data.action == 'paySuccess' || data.action == 'waiterStart') {
                    mailru.paymentWait();
                }
                else if (data.action == 'payButton') {
                    mailru.paymentInvoice();
                }
                else if (data.action == 'payError') {
                    mailru.paymentCanceled();
                }
                return;
            }
        }
    }
    window.addEventListener('message', processDmrCallback, false);

    function processAdsCallback(e) {
        const eventList = ["adCompleted", "adDismissed", "adError"];
        if(typeof e.data === "string" && eventList.includes(e.data)){
            mailru.transmitAdsCallback(e.data);
        }
        if(typeof e.data === "object" && eventList.includes(e.data.type)){
            mailru.transmitAdsObjectCallback(e.data);
        }
    }

    window.addEventListener("message", processAdsCallback, false);

    var ovlHTML = '<div class="ovl-wrap">\
          <div class="ovl">\
            <i class="popup__close js-ovl-close">&#x2715;</i>\
          </div><div class="middle"></div>\
        </div>',
        ovlFadeHTML = '<div class="ovl-fade"></div>',
        ovlArrows = '<div class="icon-wrap icon-wrap--xsm slider-arrow-left"><i class="icon icon--xsm icon--arr-left"></i><div class="b-link js-ovl-prev"></div></div>\
               <div class="icon-wrap icon-wrap--xsm slider-arrow-right"><i class="icon icon--xsm icon--arr-right"></i><div class="b-link js-ovl-next"></div></div>',
        ovlOpenLink = $('.js-ovl-open');


    $(document).on('click', '.js-ovl-close', function(event) {
        if (mailru.paymentWaitMutex) {
            console.log('Payment window close blocked by paymentWaitMutex');
            return;
        }
        $('.ovl-fade').remove();
        $('.ovl-wrap').remove();
        var $body = $('body').removeClass('ovl-opened').removeClass('ovl-billing');
        if ($body.hasClass('js-billing')) {
            $body.removeClass('js-billing');
            mailru.paymentWindowClosed();
        }
        if ($body.hasClass('js-confirm') || $body.hasClass('js-register')) {
            $body.removeClass('js-confirm').removeClass('js-register');
            mailru.confirmWindowClosed();
        }
    });
    $(document).on('keyup',function(e) {
        if($('body').hasClass('ovl-opened')){
            switch (e.keyCode) {
                case 27:
                    $('.js-ovl-close').trigger('click');
                    break;
            }
        }
    });
    $(document).on('click', '.js-reg', function() {
        if ($(this).hasClass('disabled')) {
            return;
        }
        return get_csrf_jwt_token().then(token => {
        var confirm = $('body').hasClass('js-confirm') ? true : false;
        $.ajax({
            url: mailru.platformUrl + mailru.external.appid + (confirm ? '/user/confirm_set' : '/user/register'),
            data: {...registerParams, ...{csrfmiddlewaretoken_jwt: token}},
            method: confirm ? 'GET' : 'POST',
            xhrFields: {
                withCredentials: true
            },
            success: function (data){
                if (data && data.errcode && (data.errcode == 1004 || data.errcode == 1000)) {
                    $('.ovl')
                        .find(".popup__inner p")
                        .text($('input.error_message_1004').val())
                        .css("color", "red");
                    $('.ovl').find(".popup__form__button").addClass("disabled").removeClass('.js-reg');
                    return;
                }
                if (mailru.external) {
                    if (confirm && mailru.external.userConfirmCallback) {
                        mailru.external.userConfirmCallback(data);
                    }
                    else if (mailru.external.registerUserCallback) {
                        if (isBattleArena || isGlobalCity) {
                            gtmPushEvent({ event: `${appEventName}_Registration` });
                        }

                        mailru.external.registerUserCallback(data);
                    }
                }
                $('body').removeClass('js-confirm').removeClass('js-register');
                $('.js-ovl-close').trigger('click');
            }
        });
        })
    });
    $(document).on('click', '.js-gmr-signin-btn', function() {
       mailru.authUser();
    });

    function ovl_open(_url, _args, _width, _extra_class){
        _args = _args || {};
        _width = _width || 350;
        _extra_class = _extra_class || "";
        $.ajax({
            type: 'POST',
            url: mailru.platformUrl+mailru.external.appid+_url,
            xhrFields: {
                withCredentials: true
            },
            data: _args,
            success: function (data){
                exitFullScreen();
                if (!$('.ovl-wrap').length) {
                    $('body').append(ovlFadeHTML).addClass('ovl-opened ' + _extra_class).append(ovlHTML);
                }

                // Уменьшить ширину попапа для платежки мидас
                if (data.includes('https://co.vkpay.io') && _width > 520) {
                    _width = 520;
                }

                $('.ovl').css('min-width', _width);
                $('.ovl').html('<i class="popup__close js-ovl-close">&#x2715;</i>' + data);
            }
        });
    }

    function connected(externalApi){
        mailru.external = externalApi;
    }

    function error(err) {
        throw new Error('iframeApi error ' + err);
    }

    iframeApi(mailru, {debug: false}).then(connected, error);

}(window.iframeApi));
